

























































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import validations from "@/plugins/validations";
import { UtenteForm, Utente, getAllUtentesServer, UtenteTotalCards } from "@/plugins/utils/utentesUtils";
import { ConsultaFormData, getConsultaHelpers, Seguro, Consulta, consultaServer, checkTratamentoAux, Tratamentos } from "@/plugins/utils/consultaUtils";
import { CartaoForm, Cartao } from "@/plugins/utils/cartaoUtils";
import { checkDoc, checkRecepcao, checkTerapeuta, copyArrayJson, dateStringToDateDate, GenerateFriendlyName, pad } from '../plugins/utils/utils';

@Component({
  components: {
    TitleArea
  }
})
export default class ConsultaForm extends Vue {
  formValid = false;
  validations = validations;
  utente: UtenteForm = {id: null, nome: "", telefone: "", codigo: "", observacoes: ""};
  date = new Date();
  consulta: ConsultaFormData = {
    id: null,
    tratamentos: null,
    data: this.date.getFullYear()+"-"+ pad(this.date.getMonth()+1, 2)+"-"+pad(this.date.getDate(), 2),
    hora: null,
    flag_doc: 0,
    flag_recepcao: 0,
    flag_alta: 0
  };
  cartao: CartaoForm = {id: null, diagnostico: "", observacoes:"", ap:"", tratamento:"", transporte:false, seguro: null, data_fim_transporte: null, flag_isento: false, info_espera: ""};

  tratamento_aux = "";
  separator_aux = this.$store.getters.separatorAux;

  info_espera = "";

  menu2 = false;
  menu3 = false;
  menu4 = false;

  primaryColor = this.$vuetify.theme.themes.light.primary;

  seguroHelper: Seguro | string = "";
  seguros: Seguro[] | null = [];
  get segurosList(): Seguro[] {
    if(this.seguros == null){
      return [];
    }
    else {
      return this.seguros;
    }
  }

  seguroChange(): void {
    // console.info("seguro",this.seguroHelper);
    if(typeof this.seguroHelper === "undefined" || this.seguroHelper == null){
      this.cartao.seguro = null;
      this.consulta.tratamentos = null;
    } 
    else if(typeof this.seguroHelper !== "string"){
      this.cartao.seguro = this.seguroHelper.id;
      this.consulta.tratamentos = this.seguroHelper.n_tratamentos;
    } else {
      this.cartao.seguro = this.seguroHelper;
    }
  }

  consultaObject: Consulta | null = null;
  cartaoObject: Cartao | null = null;
  utenteObject: Utente | null = null;
  created() {
    
    let id_consulta = null;
    let id_cartao = null;
    if(this.$route.params.id){
      id_consulta = parseInt(this.$route.params.id);
    }
    if(this.$route.params.id_cartao){
      id_cartao = parseInt(this.$route.params.id_cartao);
    }

    if(id_consulta != null){
      this.$store.commit("setLoading", true);
      this.getData(id_consulta, null, null);
      this.dialog_initial = false;
    }
    else if(id_cartao != null){
      this.$store.commit("setLoading", true);
      this.getData(null, id_cartao, null);
      this.dialog_initial = false;
    }
    else {
      this.changeOption();
    }
    

    if(this.$route.name){
      this.processUi(this.$route.name as string);
    }
  }

  terapeuta_nome = "";
  sessions: {total: number; actual: number} | null = null;
  sessions_act: {total: number; actual: number} | null = null;
  getData(id_consulta: number | null, id_cartao: number | null, id_utente: number | null){
    getConsultaHelpers(
      id_consulta,
      id_utente,
      id_cartao,
      (helpers) => {
        // console.log(helpers);
        this.seguros = helpers.seguros;
        // console.log(this.seguros);
        if(helpers.consulta) {
          this.consultaObject = new Consulta(helpers.consulta);
          this.consulta = this.consultaObject.consultaForm;
          if(this.consulta.tratamentos == 0) this.consulta.tratamentos = null;
        }
        if(helpers.cartao) {
          // console.log(helpers.cartao);
          this.cartaoObject = new Cartao(helpers.cartao);
          this.cartao = this.cartaoObject.cartaoForm;

          if(this.cartao.tratamento){
            const tratamentos = checkTratamentoAux(this.cartao.tratamento, this.separator_aux);
            this.cartao.tratamento = tratamentos.tratamento;
            this.tratamento_aux = tratamentos.tratamento_aux;
          }
          
          // console.log(this.cartao);
          if(this.cartao.seguro != null && this.seguros){
            for (let index = 0; index < this.seguros.length; index++) {
              const seguro = this.seguros[index];
              if(seguro.id == this.cartao.seguro){
                this.seguroHelper = seguro;
                index = this.seguros.length;
                if(!this.consulta.tratamentos){
                  this.consulta.tratamentos = seguro.n_tratamentos;
                }
              }
            }
          }
        }

        
        // console.log("🚀 ~ file: Consulta.vue ~ line 574 ~ ConsultaForm ~ getData ~ helpers.utente", helpers.utente)
        if(helpers.utente) {
          this.utenteObject = new Utente(helpers.utente);
          this.utente = this.utenteObject.utenteForm;
        }
        
        if(helpers.terapeuta){
          // console.log(helpers.terapeuta);
          this.terapeuta_nome = helpers.terapeuta;
        }
        if(helpers.sessions != undefined){
          this.sessions = helpers.sessions;
        }
        if(helpers.sessions_act != undefined){
          this.sessions_act = helpers.sessions_act;
        }
        this.$store.commit("setLoading", false);
      },
      () => {
        // console.log("Erros", err);
        this.$store.commit("setLoading", false);
      }
    );
  }

  tratamentosDividedDinamico(tratamento: string): Tratamentos | null{
    if(tratamento){
      return checkTratamentoAux(tratamento, this.$store.getters.separatorAux);
    } else {
      return null;
    }
  }

  saveAction(): void {
    this.$store.commit("setError", {flag: false, text: "", status: "error"});
    const formValid = (this.$refs.consultaForm as Vue & { validate: () => boolean }).validate();
    // console.log(this.cartao);
    if(formValid){
      if(this.tratamento_aux){
        this.cartao.tratamento += this.separator_aux[0];
        this.cartao.tratamento += this.tratamento_aux;
      }
      this.callServer();
    } else {
      this.$store.commit("setError", {flag: true, text: "Preencha todos os campos obrigatórios!", status: "error"});
    }
  }

  callServer(): void {
    this.$store.commit("setLoading", true);
    if(this.$route.name as string == "IniciarConsulta"){
      this.consulta.flag_doc = 1;
      // console.log("alte", this.consulta.flag_alta);
      if(this.consulta.flag_alta == 1){
        this.consulta.flag_recepcao = 1;
      }
    }
    
    consultaServer(
      this.consulta,
      this.cartao,
      this.utente,
      () => {
        this.$store.commit("setError", {flag: true, text: "Operação feita com sucesso!", status: "success"});
        this.checkoutRoute();
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Ocorreu um erro ao inserir no servidor...", status: "error"});
        this.$store.commit("setLoading",false);
      }
    );

  }

  // DIALOG INITIAL
  dialog_initial = true;
  flag_new = false;
  closeDialog(){
    this.getData(null, null, null);
    this.dialog_initial = false;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: Array<any> = [
    {
      text: "Nome",
      align: 'start',
      sortable: true,
      value: 'nome',
    },
    {
      text: "Código",
      align: 'start',
      sortable: true,
      value: 'codigo',
    },
    {
      text: "Telefone",
      align: 'start',
      sortable: true,
      value: 'telefone',
    },
    // {
    //   text: "Diagnostico (s)",
    //   align: 'start',
    //   sortable: true,
    //   value: 'diagnosticos',
    // },
    {
      text: "Seleccionar",
      align: 'center',
      sortable: true,
      value: 'selecionar',
    },
  ];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers2: Array<any> = [
    {
      text: "#",
      align: 'start',
      sortable: true,
      value: 'id',
    },
    {
      text: "Tratamento",
      align: 'start',
      sortable: true,
      value: 'tratamento',
    },
    {
      text: "Seleccionar",
      align: 'center',
      sortable: true,
      value: 'selecionar',
    },
  ];
  get itensPage(): number {
    if( !(this.$store.getters.userData && this.$store.getters.userData.itens_pag) ){
      return 10;
    }
    else{
      return this.$store.getters.userData.itens_pag;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  footerOptions: any = {
    "items-per-page-options": [this.itensPage, -1],
    "items-per-page-text": "Linhas/página",
    "items-per-page-all-text": "Todos"
  } 
  search = "";
  utentesList: UtenteTotalCards[] = [];
  utentes_loading = false;
  errorUtentes = false;
  changeOption(){
    // console.log("change");
    if(!this.flag_new){
      this.utenteSel = null;
      this.utentes_loading = true;
      this.errorUtentes = false;
      this.utentesList = [];
      getAllUtentesServer(
        (utentes: UtenteTotalCards[]) => {
          // console.log("u",utentes)
          this.utentesList = copyArrayJson(utentes);
          this.utentes_loading = false;
        },
        () => {
          this.utentes_loading = false;
          // console.log("err",code);
        }
      )
    }
  }
  get utentesListSearc(): UtenteTotalCards[]{
    return this.utentesList.filter(item => {
      if(!this.search || this.search.length < 3){
        return true;
      }
      else {
        const key_array: string[] = this.search.trim().split(" ");
        // console.log(key_array);
        let flag_found = 0;
        key_array.forEach(value => {
          const new_value: string = GenerateFriendlyName(value);
          if(!item.nome_pesquisa){
            item.nome_pesquisa = GenerateFriendlyName(item.nome);
          }
          // if(!item.diagnosticos_pesquisa && item.diagnosticos){
          //   item.diagnosticos_pesquisa = GenerateFriendlyName(item.diagnosticos);
          // }
          
          // (item.diagnosticos_pesquisa && item.diagnosticos_pesquisa.includes(new_value) ) ||
          if(
            (item.nome_pesquisa && item.nome_pesquisa.includes(new_value)) ||
            (item.codigo && item.codigo == value) || 
            (item.telefone && item.telefone.includes(value))
          ){
            flag_found++;
          }

        });

        if(flag_found > 0 && flag_found == key_array.length){
          return true;
        }
        else {
          return false;
        }
      }
    });
  }
  utenteSel: UtenteTotalCards | null = null;
  chooseUtente(item: UtenteTotalCards){
    if(item.cartoes == 0){
      this.getData(null, null, item.id);
      this.dialog_initial = false;
    }
    // else if(item.cartoes == 1){
    //   this.getData(null, item.cartoes_dados[0].id, null);
    //   this.dialog_initial = false;
    // }
    else if(item.cartoes > 0){
      this.utenteSel = item;
    }
  }
  chooseCard(item: {id: number; diagnostico: string}){
    this.getData(null, item.id, null);
    this.dialog_initial = false;
    this.utenteSel = null;
  }
  emptyCard(item: UtenteTotalCards){
    this.getData(null, null, item.id);
    this.dialog_initial = false;
  }
  dialogBack(){
    this.utenteSel = null;
  }

  //Routes Sigin
  checkoutRoute(){
    if(this.$route.name == "ProcessarConsulta" && this.consultaObject){
      this.$router.push(`/dashboard/consulta/${this.consultaObject.id}/marcacoes`);
    }
    else if(this.flag_cartao || this.flag_edit_consulta){
      this.$router.back();
    }
    else{
      this.$router.push("/dashboard");
    }
  }

  // UI MODIFICATIONS
  titleArea = "Consulta";
  flagTimeline = false;
  tratamento_req = false;
  flag_marcacao = false;
  flag_cartao = false;
  flag_edit_consulta = false;
  flag_show_sessions = false;
  processUi(route: string): void{
    if(route == "IniciarConsulta"){
      this.flag_show_sessions = true;
    }
    else if(route == "ProcessarConsulta"){
      this.titleArea = "Processar Consulta";
      this.flagTimeline = true;
      this.tratamento_req = true;
      this.flag_marcacao = false;
    } 
    else if(route == "Marcacao" || route == "EditarMarcacao" || route == "MarcacaoCartao" ){
      this.titleArea = "Marcação de Consulta";
      this.flagTimeline = false;
      this.tratamento_req = false;
      this.flag_marcacao = true;
    }
    else if(route == "EditarCartao"){
      this.titleArea = "Editar Cartão";
      this.flag_cartao = true;
    }
    else if(route == "EditarConsulta"){
      this.titleArea = "Editar Consulta";
      this.flag_edit_consulta = true;
    }
  }
  get title(): string{
    return this.titleArea;
  }
  get timeline(): boolean{
    return this.flagTimeline;
  }
  get tratamentosReq(): boolean{
    return this.tratamento_req;
  }

  get checkRecepcao(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel != undefined)
      return checkRecepcao(this.$store.getters.userData.nivel);
    else
      return false;
  }
  get checkDoc(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel != undefined){
      return checkDoc(this.$store.getters.userData.nivel);
    }
    else{
      return false;
    }
  }

  get checkTerapeuta(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel != undefined){
      return checkTerapeuta(this.$store.getters.userData.nivel);
    }
    else{
      return false;
    }
  }

  get checkSaude(): boolean{
    return this.checkTerapeuta || this.checkDoc ? true : false;
  }

  allowedDates(val: string): boolean {
    let flag = false;
    const date = dateStringToDateDate(val);
    if( !(date.getDay() == 6 || date.getDay() == 0) ) {
      flag = true;
    }

    return flag;
  }
}
